import React from "react";

export interface CanvasProps {
  id: string;
}

export const Canvas: React.FC<CanvasProps> = () => {
  return <></>;
};
